<template>
  <div>
    <div v-for="quiz in quizzes" :key="quiz.id">
      <Quiz :quizData="quiz"></Quiz>
    </div>
  </div>
</template>

<script>
import Quiz from "./Quiz";

export default {
  name: "Quizzes",
  components: {
    Quiz,
  },

  data() {
    return {
      quizzes: [],
    };
  },

  created() {
    this.fetchQuizzes();
  },

  methods: {
    /**
     * Fetch quizzes
     */
    fetchQuizzes() {
      const user = JSON.parse(localStorage.getItem("user"));
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      };
      this.$http
        .get(`${process.env.BASE_API_URL}/quiz/?page_num=1&items=1`, {
          headers,
        })
        .then((res) => {
          this.quizzes = res.data.data;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/quiz/Quizzes.vue